module.exports = __webpack_public_path__ + "static/media/ideaBulb.74dd6ab9.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/ideaBulb.jpg
// module id = 410
// module chunks = 0